import React from "react";

import { IssueFilterForm } from "@adsk/acc-issues-common/components/form/IssueFilterForm";
import { Issue } from "@adsk/acc-issues-types";
import {
  FiltersHeader,
  ReferencePickerPlugin,
} from "@adsk/acc-reference-picker";
import Panel from "@adsk/alloy-react-panel";
import { useTranslations } from "@adsk/acc-issues-translations";

export type FiltersPanelProps = React.ComponentProps<
  NonNullable<ReferencePickerPlugin<Issue>["FiltersPanel"]>
> & {
  fixedTypeId?: string;
};

export const FiltersPanel = ({
  filters: { searchExpression, ...filters },
  setFilters,
  open,
  floatingPanel,
  onClose,
  hasFilters,
  clearFilters,
  fixedTypeId,
}: FiltersPanelProps) => {
  const { T } = useTranslations();
  const title = T.translate("filterPanel.title")?.toString();

  return (
    <Panel
      open={open}
      floating={floatingPanel}
      renderHeader={() => (
        <FiltersHeader
          floatingPanel={floatingPanel}
          onClose={onClose}
          title={title}
          hasFilters={hasFilters}
          clearFilters={clearFilters}
        />
      )}
    >
      <Panel.Body
        style={{
          padding: 0,
        }}
      >
        <IssueFilterForm
          style={{
            height: "100%",
          }}
          filters={filters}
          handleFilterChange={(filtersDiff: Record<string, unknown>) => {
            setFilters({ ...filters, ...filtersDiff });
          }}
          fixedTypeId={fixedTypeId}
        />
      </Panel.Body>
    </Panel>
  );
};
